import * as React from 'react';
import { FC } from 'react';

import { useIntl } from 'react-intl';
import { useLocation } from 'react-router';

import { selectors, useAppSelector } from 'state/global-state';
import { useLoyaltyUser } from 'state/loyalty/hooks/use-loyalty-user';
import { DIFFERENCE_TIME_UNITS, getDifferenceToNow } from 'utils/dateTime';
import { routes } from 'utils/routing';

import { CooldownWrapper, StyledIcon, TextWrapper } from './loyalty-offers-cooldown.styled';

export const LoyaltyOffersCooldown: FC = () => {
  const { loyaltyUser } = useLoyaltyUser();
  const { formatMessage } = useIntl();
  const { pathname } = useLocation();
  const loyaltyOffersInCooldown = useAppSelector(selectors.loyalty.selectLoyaltyOffersInCooldown);
  const isOffersPage = pathname.includes(routes.offers);
  const showCooldown = loyaltyOffersInCooldown && isOffersPage;

  const diffInMin = getDifferenceToNow(
    DIFFERENCE_TIME_UNITS.MINUTES,
    loyaltyUser?.offerRedemptionAvailability?.availableAfter || ''
  );

  return showCooldown ? (
    <CooldownWrapper>
      <StyledIcon />
      <TextWrapper>
        <b>{formatMessage({ id: 'offersCooldownTitle' })}</b>
        <p>
          {formatMessage(
            { id: 'offersCooldownDescription' },
            {
              minutes: diffInMin,
            }
          )}
        </p>
      </TextWrapper>
    </CooldownWrapper>
  ) : null;
};
